// src/components/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 p-4 text-center text-gray-300">
      <div>© 2024 Bookmark Manager. All rights reserved.
         developed by <a className='text-red-700 'target='_blank' rel="noreferrer"  href='https://github.com/shiinedev/bookmark-manegar-react-and-firebase'>shiinedev</a>
      </div>
    </footer>
  );
};

export default Footer;
